module.exports = "/images/epidemic@3x.png?c1c8ffda0f1892d4bbb5a14112c7ecca";